(function () {
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminJobExtraSettingsController', AdminJobExtraSettingsController);

    function AdminJobExtraSettingsController($scope, apiClient, messenger, jobExtraSettings, elbSettings, modulesService) {
        var vm = this;
        vm.settings = jobExtraSettings;
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        vm.jobNotifySiteAssociateType = jobExtraSettings.getLinkAttribute('jobNotifySiteAssociateType','title') || null;
        vm.p2pEnabled = elbSettings.getSetting('p2p_enabled').value || elbSettings.getSetting('hexagon_p2p_enabled').value;
        vm.proactisEnabled = elbSettings.getSetting('p2p_enabled').value;
        vm.reassignOperativeAttendByEnabled = elbSettings.getSetting('reassign_operatives_attend_by_enabled').value;
        vm.selectedDocumentType = vm.settings.requireDocumentTypeWhenRaisingReactiveJob;
    }
})();

